const CategoryButtons = ({
    setShowArchived,
    showArchived,
    setIsAddingCategory,
    setIsDeletingCategory,
    setIsEditingCategory
}) => {
    return (
    <div
      className="justify-end"
      style={{ paddingBottom: "5px", textAlign: "center" }}
    >
      <button  
        className="sidebar-button" 
        style={{ backgroundColor: "#0d107e" }}
        onClick={() => setShowArchived(!showArchived)}>
        {showArchived ?
        `Hide Archived` :
        `Show Archived`}
      </button>
      <button
        className="sidebar-button"
        style={{ marginTop: "3px", backgroundColor: "#0d107e" }}
        onClick={() => setIsAddingCategory(true)}
      >
        Add Category
      </button>
      <button
        className="sidebar-button"
        style={{ marginTop: "3px", backgroundColor: "#0d107e" }}
        onClick={() => {
          setIsDeletingCategory(true);
        }}
      >
        Delete A Category
      </button>
      <button
        className="sidebar-button"
        style={{ marginTop: "3px", backgroundColor: "#0d107e" }}
        onClick={() => setIsEditingCategory(true)}
      >
        Update A Category
      </button>
    </div>
  );
};

export default CategoryButtons;